module.exports = __webpack_public_path__ + "img/Icon-SecureInbox.6eccba3d.svg";